// console.log('Cart drawer contents goes here');


class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.cartDrawerToggle = document.querySelector('.section-header-cart-drawer-toggle');
        this.cartDrawer = this;
        this.cartDrawerClose = this.querySelector('.cart-drawer-close');
        this.cartDrawerOverlay = this.querySelector('.cart-drawer-overlay');
        this.cartDrawerEmptyRedirect = this.querySelector('.cart-drawer-empty-footer');

        this.setAttribute('tabindex', '-1');

        if(this.cartDrawerToggle){
            this.cartDrawerToggle.addEventListener('click', (event) => this.onClick(event))
        }

        this.cartDrawerClose.addEventListener('click', () => this.close())
        this.cartDrawerClose.addEventListener('keyup', (event) => this.onCloseKeypress(event))
        this.cartDrawerOverlay.addEventListener('click', () => this.close())


        document.addEventListener('keyup', (event) => {
            if(event.key === 'Escape'){
                this.close();
            }
        })

        document.addEventListener('click', (event) => {
            const closeEl = document.querySelector('.cart-drawer-close');
            if(closeEl && (event.target === closeEl || closeEl.contains(event.target))){
                this.close()
                return
            }
            // "Continue shopping" — delegated so it keeps working after the
            // drawer contents are re-rendered by refreshCartDrawerUI().
            if(event.target.closest && event.target.closest('.cart-drawer-continue')){
                this.close()
            }
        })

        if( this.cartDrawerEmptyRedirect ){
            this.cartDrawerEmptyRedirect.addEventListener('click', () => this.close())
        }

        this.previousElement = this.cartDrawerToggle
    }

    onClick(event) {

        event.preventDefault();

        this.open()
    }

    onCloseKeypress(event){
        if (event.key === 'Enter') {

            this.close();
            
            // this.cartDrawerToggle.focus();

            // var quickviewElement = document.querySelector('.popup-modal-quickview:not(.inactive)');
            // if(quickviewElement){
            //     quickviewElement.querySelector('button[type="submit"]').focus();
            // }
        }
    }

    open() {
  this.previousElement = (document.activeElement || this.cartDrawerToggle);

  this.cartDrawer.setAttribute('aria-hidden', 'false');
  this.cartDrawer.classList.add('active');

  // ✅ força o browser a recalcular layout (resolve o “aparece só quando inspeciona”)
  setTimeout(() => {
    // 1) dispara resize = força reflow (muito efetivo pra imagens/lazy/carrossel)
    window.dispatchEvent(new Event('resize'));

    // 2) se existir Splide já montado, tenta refresh
    document.querySelectorAll('.splide').forEach((slider) => {
      if (slider && slider.splide && typeof slider.splide.refresh === 'function') {
        slider.splide.refresh();
      }
    });
  }, 250);

  setTimeout(() => {
    const firstLink = this.querySelector('a[href]');
    if (firstLink) firstLink.focus();
  }, 100);
}

    close() {

        // this.cartDrawerToggle.focus();
        this.previousElement.focus();
            
        this.cartDrawer.setAttribute('aria-hidden', 'true');
        this.cartDrawer.classList.remove('active')

        var quickviewElement = document.querySelector('.popup-modal-quickview:not(.inactive)');
        if(quickviewElement){
            quickviewElement.querySelector('button[type="submit"]').focus();
        }
    }

}

customElements.define('cart-drawer', CartDrawer);









(function () {
  function renderCartRecommendations() {
    const holder = document.querySelector('.cart-reco-holder[data-rec-url]');
    if (!holder) return;

    // evita ficar recarregando toda hora
    if (holder.dataset.loaded === 'true') return;
    holder.dataset.loaded = 'true';

    fetch(holder.dataset.recUrl, { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const block = doc.querySelector('.cart-drawer-recommendations');
        if (block) holder.replaceWith(block);
      })
      .catch(() => {});
  }

  // tenta carregar ao abrir o drawer (o seu tema usa .active)
  const observer = new MutationObserver(() => {
    const drawer = document.querySelector('cart-drawer.cart-drawer');
    if (drawer && drawer.classList.contains('active')) {
      setTimeout(renderCartRecommendations, 150);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    renderCartRecommendations();
  });
})();








document.addEventListener('click', function(event) {
  const button = event.target.closest('.add-to-cart-button');
  if (!button) return;
  const variantId = button.dataset.variantId;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(() => {
    // aqui você pode atualizar a contagem do carrinho ou abrir o mini-carrinho
    console.log('Produto adicionado');
  });
});







function promoteResponsiveImages(root) {
  if (!root) return;

  root.querySelectorAll('img').forEach((img) => {
    const ds = img.dataset || {};

    // Se o tema usa data-src / data-srcset, promove para src/srcset
    if (ds.src && (!img.getAttribute('src') || img.getAttribute('src') === '' || img.getAttribute('src').startsWith('data:'))) {
      img.setAttribute('src', ds.src);
    }
    if (ds.srcset) img.setAttribute('srcset', ds.srcset);
    if (ds.sizes) img.setAttribute('sizes', ds.sizes);

    // força o browser a buscar a melhor versão
    img.decoding = 'async';
  });
}

function reinitLazyLoad(root) {
  if (!root) return;

  // 1) Luma/Lazysizes (muito comum em temas Shopify)
  if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
    // garante que imagens novas estejam elegíveis
    root.querySelectorAll('img[data-src], img[data-srcset]').forEach((img) => {
      if (!img.classList.contains('lazyload') && !img.classList.contains('lazyloaded')) {
        img.classList.add('lazyload');
      }
    });

    window.lazySizes.loader.checkElems();
  }

  // 2) Fallback: promove data-attrs (caso não tenha lazysizes)
  promoteResponsiveImages(root);

  // 3) Força reflow (ajuda o browser a recalcular srcset/sizes)
  requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
}






/* =========================================================
   CART RECOMMENDATIONS – QUICK ADD (final + no pixel)
   ========================================================= */

// Show a visible, dismissible error inside the cart drawer when a quick-add
// fails (e.g. sold out) — previously these only went to the console.
function showCartQuickAddError(message) {
  const container =
    document.querySelector('cart-drawer .cart-drawer-contents') ||
    document.querySelector('cart-drawer') ||
    document.body;
  if (!container) return;

  let toast = container.querySelector('.cart-quickadd-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'cart-quickadd-toast';
    toast.setAttribute('role', 'alert');
    container.prepend(toast);
  }
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => toast.classList.remove('is-visible'), 5000);
}

function hydrateImages(root) {
  if (!root) return;

  root.querySelectorAll('img').forEach((img) => {
    // promove lazy patterns comuns
    if (img.dataset && img.dataset.src && (!img.src || img.src.includes('data:'))) {
      img.src = img.dataset.src;
    }
    if (img.dataset && img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
    }
    if (img.dataset && img.dataset.sizes) {
      img.sizes = img.dataset.sizes;
    }

    // força carregamento mais agressivo pós-render
    img.loading = 'eager';
    img.decoding = 'async';

    // tenta “destravar” placeholder
    try { img.decode?.(); } catch (_) {}
  });
}

async function refreshCartDrawerUI() {
  const res = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`, {
    method: 'GET',
    credentials: 'same-origin'
  });
  const sections = await res.json();

  // Atualiza apenas o conteúdo do drawer
  if (sections['cart-drawer']) {
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');

    const newContents = doc.querySelector('.cart-drawer-contents');
    const currentContents = document.querySelector('cart-drawer .cart-drawer-contents');

    if (newContents && currentContents) {
      currentContents.innerHTML = newContents.innerHTML;

      // ✅ resolve pixelado / placeholders
      hydrateImages(currentContents);
    }

    // mantém aberto
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.add('active');
  }

  // Atualiza bolha/contador
  if (sections['cart-icon-bubble']) {
    const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    const newBubble = doc.querySelector('#cart-icon-bubble, .cart-icon-bubble');
    const currentBubble = document.querySelector('#cart-icon-bubble, .cart-icon-bubble');
    if (newBubble && currentBubble) currentBubble.replaceWith(newBubble);
  }

  // reflow/slider (se existir)
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
    document.querySelectorAll('.splide').forEach((slider) => {
      if (slider && slider.splide && typeof slider.splide.refresh === 'function') {
        slider.splide.refresh();
      }
    });
  }, 50);
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('.cart-reco-quickadd');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = button.getAttribute('data-variant-id') || button.dataset.variantId;
  if (!variantId) return;

  try {
    button.classList.add('is-loading');
    button.disabled = true;

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    const data = await res.json().catch(() => null);

    if (!res.ok) {
      // Shopify returns { description, message } on add errors (e.g. sold out).
      const message =
        (data && (data.description || data.message)) ||
        'Sorry, this item could not be added to your cart.';
      showCartQuickAddError(message);
      return;
    }

    await refreshCartDrawerUI();

  } catch (error) {
    console.error('[Cart recos] Quick add error:', error);
    showCartQuickAddError('Something went wrong. Please try again.');
  } finally {
    button.classList.remove('is-loading');
    button.disabled = false;
  }
}, { capture: true });










(function () {
  function pickLargestFromSrcset(srcset) {
    if (!srcset) return null;
    const candidates = srcset
      .split(',')
      .map(s => s.trim())
      .map(part => {
        const [url, w] = part.split(/\s+/);
        const width = parseInt((w || '').replace('w', ''), 10);
        return { url, width: Number.isFinite(width) ? width : 0 };
      })
      .filter(c => c.url);

    if (!candidates.length) return null;
    candidates.sort((a, b) => b.width - a.width);
    return candidates[0].url;
  }

  function fixCartDrawerImages() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('img.lazy-loading-image__main').forEach(img => {
      const displayed = img.getBoundingClientRect().width || 0;

      // Se já está ok, não mexe
      if (img.complete && img.naturalWidth >= displayed * 1.5) return;

      const best = pickLargestFromSrcset(img.getAttribute('srcset'));

      // Se tem srcset, força o maior candidato
      if (best) {
        // evita loop infinito
        if (img.dataset.forcedHiRes === '1') return;
        img.dataset.forcedHiRes = '1';

        // força imagem grande (somente no cart drawer)
        img.src = best;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }

      // opcional: se tiver placeholder por cima, some com ele quando carregar
      const wrap = img.closest('.lazy-loading-image');
      const placeholder = wrap?.querySelector('img.lazy-loading-image--placeholder');
      if (placeholder) {
        img.addEventListener('load', () => {
          placeholder.style.opacity = '0';
          placeholder.style.pointerEvents = 'none';
        }, { once: true });
      }
    });
  }

  // roda no load
  document.addEventListener('DOMContentLoaded', fixCartDrawerImages);

  // roda após mudanças no DOM (update do drawer via AJAX)
  const obs = new MutationObserver(() => fixCartDrawerImages());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();









document.addEventListener('cart:updated', () => {
  document
    .querySelectorAll('cart-drawer img.lazy-loading-image--placeholder')
    .forEach(img => img.remove());
});
